import * as React from 'react';

import { Box, H3, Text } from '@opendoor/bricks/core';

import { CasaAddress } from './UnsubscribePage';

interface ISuccessPageProps {
  casaAddress: CasaAddress | null;
}

export class SuccessPage extends React.PureComponent<ISuccessPageProps> {
  public render() {
    const { casaAddress } = this.props;
    const unit =
      casaAddress && casaAddress.unitNumber && casaAddress.unitNumber
        ? casaAddress.unitType + ' ' + casaAddress.unitNumber
        : null;

    return (
      <Box maxWidth="600px">
        <H3 width="100%" textAlign={['center', null, 'left']} mb={7}>
          You’ve successfully unsubscribed!
        </H3>
        <Text textAlign={['center', null, 'left']} mb={7}>
          We’ve removed {casaAddress ? casaAddress.street : 'your home'}
          {unit && `, ${unit}`} from our mailing list. You may receive one more piece of mail if
          it’s been processed before your unsubscribe which may arrive over the next 6-8 weeks.
        </Text>
      </Box>
    );
  }
}
